import { type Unit, unitMapping } from '#src/lib/style.ts';

const DEFAULT_STAT_WIDTH: Unit = 6;

export const squadGridTemplateColumns = <T extends string>(
  stats: T[],
  statWidths: Partial<Record<T, Unit>> = {}
) =>
  [
    'auto',
    '1fr',
    ...stats.map(stat => unitMapping[statWidths[stat] ?? DEFAULT_STAT_WIDTH]),
  ].join(' ');
